
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"19.999"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1748"}},[_c('path',{attrs:{"data-name":"Path 1125","d":"M19 0H1a1 1 0 00-1 1v17.966c0 1.1.637 1.364 1.414.586L4.967 16H19a1 1 0 001-1V1a1 1 0 00-1-1z","fill":"#adadad"}}),_c('g',{attrs:{"data-name":"Group 1747","transform":"translate(-896.376 -304.768)"}},[_c('circle',{attrs:{"data-name":"Ellipse 229","cx":"1.25","cy":"1.25","r":"1.25","transform":"translate(905.626 316.768)"}}),_c('path',{attrs:{"data-name":"Path 1126","d":"M906.876 315.768a1 1 0 01-1-1v-2a1 1 0 011-1 1.5 1.5 0 10-1.5-1.5 1 1 0 01-2 0 3.5 3.5 0 114.5 3.354v1.146a1 1 0 01-1 1z"}})])])])
          )
        }
      }
    